export interface GroceryItem {
    category_item_id: string;
    item_name: string;
    quantity: string;
    user_id: string;
    category: string;
  }

  export interface Chef {
    id: string;
    name: string;
    establishment_name: string;
    establishment_type: EstablishmentType;
    cuisine: string;
    image_url: string;
    recipe_ids: string[];
    location: {
      zipcode: string;
      city: string;
      state: string;
      country: string;
    };
  }


export interface Recipe {
    recipe_id: string;
    name: string;
    description: string;
    meal_type: string;
    diet_type: string;
    cooking_time: string;
    cuisine: string;
    created_by: string;
    ingredients: string[];
    instructions: string[];
    image_url?: string;
  }
  
  export enum EstablishmentType {
    All = 'All',
    CloudKitchen = 'Cloud Kitchen',
    HomeCooking = 'Home Cooking',
    Restaurant = 'Restaurant',
    FoodTruck = 'Food Truck',
    CateringService = 'Catering Service',
    PopUpDining = 'Pop-Up Dining',
    PersonalChef = 'Personal Chef',
    MealDelivery = 'Meal Delivery Service'
  }

  
  // ... (other types remain the same)